import React, { useMemo } from 'react';

const WorkPermitStep2Equipment = ({ formData, handleChange, formErrors, plants, lines, machines }) => {
  const filteredLines = useMemo(() => {
    if (!formData.plantId) return lines;
    return lines.filter((l) => l.plantId?.toString() === formData.plantId);
  }, [formData.plantId, lines]);

  const filteredMachines = useMemo(() => {
    if (!formData.lineId) return machines;
    return machines.filter((m) => m.lineId?.toString() === formData.lineId);
  }, [formData.lineId, machines]);

  return (
    <div className="work-permit-step">
      <h3 className="form-section-title">2. Equipment & Area</h3>
      <div className="form-row">
        <div className="form-group">
          <label>Plant</label>
          <select name="plantId" value={formData.plantId} onChange={handleChange}>
            <option value="">Select plant</option>
            {plants.map((p) => (
              <option key={p.plantId} value={p.plantId}>
                {p.plantName}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label>Line / Area</label>
          <select name="lineId" value={formData.lineId} onChange={handleChange}>
            <option value="">Select line</option>
            {filteredLines.map((l) => (
              <option key={l.lineId} value={l.lineId}>
                {l.lineName}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label>Equipment *</label>
          <select
            name="equipmentId"
            value={formData.equipmentId}
            onChange={handleChange}
            className={formErrors.equipmentId ? 'error' : ''}
          >
            <option value="">Select equipment</option>
            {filteredMachines.map((m) => (
              <option key={m.machineId} value={m.machineId}>
                {m.machineName} ({m.machineCode})
              </option>
            ))}
          </select>
          {formErrors.equipmentId && <span className="field-error">{formErrors.equipmentId}</span>}
        </div>
      </div>
    </div>
  );
};

export default WorkPermitStep2Equipment;

